import React from "react";
import Hero from "./Hero";
import Projects from "./Projects";
import video from "../images/v1.mp4";
import Skills from "./Skills";

const Home = () => {
  return (
    <>
      <video src={video} autoPlay muted loop className="video-bg" />
      <div className="overflow-x-hidden min-h-screen bg-gradient-to-r from-[#000000] to-[#151414b0]">
        <Hero />
        <Projects />
        <Skills/>
      </div>
    </>
  );
};

export default Home;
